/*import Noty from 'noty';*/

export default function () {
    document.querySelectorAll('i[data-mass-action]').forEach(item => {
        item.addEventListener('click', function () {
            const type = this.getAttribute('data-mass-action');
            const value = this.previousElementSibling.value;

            document.querySelectorAll(`input[${type}]`).forEach(item => {
                item.value = value;
            });
        });
    });

    document.querySelectorAll('.column-swap').forEach(item => {
        item.addEventListener('click', function () {
            let count = 0;
            const target = document.querySelector(`#${this.getAttribute('data-column-target')}`);

            if (!target) return;

            target.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                const checked = checkbox.checked;

                if (!checked) {
                    count++;
                }

                checkbox.checked = !checked;
                checkbox.dispatchEvent(new Event('change'));
            });

            //if (count > 0) {
            //    new Noty({
            //        type: 'info',
            //        text: `Oznaczono ${count} wierszy`
            //    }).show();
            //}
        });
    });
}